import {ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output} from "@angular/core";

@Component({
  selector: 'int-dropdown-chevron',
  templateUrl: './int-dropdown-chevron.component.html',
  styleUrls: ['./int-dropdown-chevron.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntDropdownChevronComponent {
  @Input() isActive: boolean | null = false;
  @Output() onClick = new EventEmitter<Event>();

  @HostListener('click', ['$event']) click(event: Event) {
    this.onClick.emit(event);
  }
}
